export default __webpack_public_path__ + "static/media/img12.034775c4.png";